'use strict';

// https://262.ecma-international.org/6.0/#sec-isarray
module.exports = require('../helpers/IsArray');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2021/IsArray.js
// module id = L3dv
// module chunks = 78